export const systemConstants = {
    infoEmail: "info@westparcel.com"
};